(() => {
  const mobileQuery = window.matchMedia('(max-width: 620px)');

  const syncGroups = (root = document) => {
    root.querySelectorAll('.qlf').forEach((footer) => {
      const groups = footer.querySelectorAll('.qlf__nav-group');
      groups.forEach((group) => {
        if (mobileQuery.matches) {
          if (group.dataset.qlfMobileReady !== 'true') group.open = false;
          group.dataset.qlfMobileReady = 'true';
        } else {
          group.open = true;
          delete group.dataset.qlfMobileReady;
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => syncGroups());
  document.addEventListener('shopify:section:load', (event) => syncGroups(event.target));
  mobileQuery.addEventListener?.('change', () => syncGroups());
})();
